import React from 'react';
import { useTranslation } from 'react-i18next';
import { BUSINESS_TYPE, STEEL_MAKER } from '../../../constants';
import type { BusinessType, SteelMaker } from '../../../types/common';
import type { ConditionDetailType } from '../../../types/condition';

interface TableOrdinaryProps {
  steelMaker: SteelMaker;
  businessType: BusinessType;
  detailOrdinary: ConditionDetailType[];
}

const TableOrdinary = ({ steelMaker, businessType, detailOrdinary }: TableOrdinaryProps): React.ReactElement => {
  const { t } = useTranslation();
  const isDomestic: boolean = businessType === BUSINESS_TYPE.DOMESTIC;
  const isExport: boolean = businessType === BUSINESS_TYPE.EXPORT;
  const isDomesticAichi: boolean = businessType === BUSINESS_TYPE.DOMESTIC && steelMaker === STEEL_MAKER.AICHISTEEL;
  const isDomesticNsc: boolean = businessType === BUSINESS_TYPE.DOMESTIC && steelMaker === STEEL_MAKER.NIPPONSTEEL;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <p className="mb-1">{t('condition.normal')}</p>
      <table className="table table-condition-ordinary">
        <thead>
          <tr>
            <>
              <th>{t('condition.customer')}</th>
              <th>{t('condition.customerName')}</th>
            </>
            {(isDomesticNsc || isDomesticAichi) && (
              <>
                <th>{t('deliveryLocation.deliveryLocation')}</th>
                <th>{t('deliveryLocation.deliveryLocationName')}</th>
              </>
            )}
          </tr>
        </thead>
        {detailOrdinary.map((detail, index) => {
          return (
            <tbody key={'detailOrdinary' + index}>
              <tr>
                <>
                  <td>{detail.customer}</td>
                  <td>{detail.customerName ?? '\u00A0'}</td>
                </>
                {(isDomesticNsc || isDomesticAichi) && (
                  <>
                    <td>{detail.deliveryLocation}</td>
                    <td>{detail.deliveryLocationName ?? '\u00A0'}</td>
                  </>
                )}
              </tr>
            </tbody>
          );
        })}
      </table>
    </>
  );
};

export default TableOrdinary;
